"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rowtooltip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var tooltip_1 = require("../../tooltip");
function rowtooltip(options) {
    return {
        getInfo: function () { return ({ name: "rowtooltip" }); },
        onInjectRow: function (next) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var result = next.apply(void 0, tslib_1.__spread(args));
            // 对于提供了 tooltip 的，用 tooltip 包裹
            var _a = tslib_1.__read(args, 1), record = _a[0];
            var tooltip = options.tooltip(record);
            if (tooltip) {
                result.row = (react_1.default.createElement(TooltipWrapper, { key: result.row.key, tooltip: tooltip }, result.row));
            }
            return result;
        }; },
    };
}
exports.rowtooltip = rowtooltip;
function TooltipWrapper(_a) {
    var children = _a.children, tooltip = _a.tooltip, props = tslib_1.__rest(_a, ["children", "tooltip"]);
    return (react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip }, react_1.default.cloneElement(react_1.default.Children.only(children), tslib_1.__assign(tslib_1.__assign({}, props), { 
        // eslint-disable-next-line react/destructuring-assignment
        className: classnames_1.default(props.className, children.props.className) }))));
}
//# sourceMappingURL=rowtooltip.js.map